import eventBus from "./eventBus";

let socket;
let currentUserId;
let reconnectTimeout;
let messageCallback = () => {};

function connectWebSocket() {
  if (!currentUserId) {
    console.warn('[WS] Cannot connect — currentUserId is not set.');
    return;
  }

  // console.log('[WS] Connecting...');
  // socket = new WebSocket(`wss://www.europeanbrokermeeting.com/ws/`);
  // socket = new WebSocket(`ws://localhost:4001/ws/`);
  const user = JSON.parse(localStorage.getItem("user"));
  const jwtToken = user?.token;

  socket = new WebSocket(`wss://www.europeanbrokermeeting.com/ws/?token=${jwtToken}`);


  socket.onopen = () => {
    socket.send(JSON.stringify({ type: 'auth', userId: currentUserId }));
    // console.log('[WS] Connected');
  };

  socket.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);

      if (data.type === 'ping') {
        // console.log('ping received')
        socket.send(JSON.stringify({ type: 'pong' }));
        return;
      } 
      else if(data.type == 'message-read') {
        // console.log('message-read received')
        eventBus.$emit("message-read", { contactId: data.contactId });
        return;
      } 
      else if(data.type == 'user-connected') {
        // console.log('user-connected received')
        eventBus.$emit("user-connected", { contactId: data.contactId });
        return;
      }
      else if(data.type == 'user-disconnected') {
        // console.log('user-disconnected received')
        eventBus.$emit("user-disconnected", { contactId: data.contactId });
        return;
      }
      else if(data.type == 'user-typing') {
        // console.log('user-typing received')
        eventBus.$emit("user-typing", { contactId: data.contactId });
        return;
      }
      else if(data.type == 'user-stopped-typing') {
        // console.log('user-stopped-typing received')
        eventBus.$emit("user-stopped-typing", { contactId: data.contactId });
        return;
      }

    } catch (err) {
      console.log(err)
    }

    messageCallback({ type: 'new message', data: event.data });
  };

  socket.onerror = (error) => {
    // console.error('[WS] Error:', error);
  };

  socket.onclose = () => {
    // console.log('[WS] Closed. Reconnecting...');
    clearTimeout(reconnectTimeout);
    reconnectTimeout = setTimeout(connectWebSocket, 3000);
  };

  return socket;
}

export function initWebSocket(userId, onMessage) {
  currentUserId = userId;
  messageCallback = onMessage;
  return connectWebSocket();
}

export function disconnectWebSocket() {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.close();
  }
}
